export const SET_QUEUE = 'SET_QUEUE'
export const RESET_QUEUE = 'RESET_QUEUE'
